import {
    CLOSE_POS_HUB_DIALOG_ERROR,
    SHOW_POS_HUB_DIALOG_ERROR,
    SHOW_POS_HUB_DIALOG_WARNING,
} from 'store/actions/ui.action'
import { CancelRefreshTokenExpired, UnknownErrorMessage } from 'types/errorText'
import errorMessages from 'utilities/errorMessages'
import { Dictionary } from 'utilities/typeUtility/typeUtility'

export const SHOW_ERROR_DIALOG = 'SHOW_ERROR_DIALOG'
export const CLOSE_ERROR_DIALOG = 'CLOSE_ERROR_DIALOG'

interface IState {
    open: boolean
    message: string
    arg: Dictionary<string>
    hideOKBtn?: boolean
    hideCloseBtn?: boolean
}

const initialState: IState = {
    open: false,
    message: '',
    arg: {},
    hideOKBtn: false,
    hideCloseBtn: false,
}

export default function errorDialogReducer(
    state: IState = initialState,
    { type, payload }: { type: string; payload: any },
) {
    switch (type) {
        case SHOW_POS_HUB_DIALOG_ERROR: {
            if (state.open) {
                return {
                    ...state,
                    message: payload,
                    hideOKBtn: false,
                }
            }
            return state
        }
        case SHOW_POS_HUB_DIALOG_WARNING: {
            return {
                message: payload,
                open: true,
                hideOKBtn: true,
                hideCloseBtn: true,
            }
        }
        case SHOW_ERROR_DIALOG:
            const { message, arg } = errorMessages(payload)
            if (message === CancelRefreshTokenExpired) {
                return state
            }
            if (message === UnknownErrorMessage) return state
            return {
                open: true,
                message,
                arg,
            }
        case CLOSE_ERROR_DIALOG:
        case CLOSE_POS_HUB_DIALOG_ERROR:
            return {
                ...state,
                open: false,
                hideOKBtn: false,
            }
        default:
            return state
    }
}
